import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Button, Card, Input } from '@clari/ui'
import { AuthLayout } from '@/components/AuthLayout'
import { authApi } from '@/lib/auth-api'

export function ForgotPassword() {
  const { t } = useTranslation('auth')
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)

  async function onSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    setLoading(true)
    try {
      await authApi.forgotPassword(email)
    } finally {
      // Always show the same confirmation — never reveal whether the email exists.
      setSent(true)
      setLoading(false)
    }
  }

  return (
    <AuthLayout>
      <Card>
        {sent ? (
          <>
            <h1 className="text-2xl font-semibold">{t('forgot_password.sent_title')}</h1>
            <p className="mt-1 text-text-muted">{t('forgot_password.sent_body', { email })}</p>
            <Link
              to="/login"
              className="mt-6 inline-block text-sm font-medium text-text underline"
            >
              {t('forgot_password.back_to_signin')}
            </Link>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-semibold">{t('forgot_password.title')}</h1>
            <p className="mt-1 text-text-muted">{t('forgot_password.subtitle')}</p>
            <form className="mt-6 flex flex-col gap-4" onSubmit={onSubmit}>
              <Input
                label={t('forgot_password.email_label')}
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <Button type="submit" disabled={loading}>
                {t('forgot_password.submit')}
              </Button>
            </form>
            <Link
              to="/login"
              className="mt-4 inline-block text-sm text-text-muted hover:text-text"
            >
              {t('forgot_password.back_to_signin')}
            </Link>
          </>
        )}
      </Card>
    </AuthLayout>
  )
}
